const BaseComponent = require('base/base-component');
const Server = require('helper/server');

const listTpl = Handlebars.templates['guigang/comps/rightList/templates/list-tpl'];
class transactionTabs extends BaseComponent {
  init () {
    this.categoryName = this.$el.find('[name="categoryName"]').val();
    if (this.categoryName === '代理机构') {
      const requestData = {
        pageNo: 1,
        pageSize: 10,
        regDist: 450899
      };
      Server.getAgentList({ data: requestData })
        .done((resp) => {
          this.$el.find('ul').prepend(listTpl({
            _DATA_: resp.data,
            _PATH_: '/ggcgAgent/ggcgAgentAll/detail.html'
          }));
        });
    }
  }
}
module.exports = transactionTabs;
